<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="700px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-3 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px"
              >mdi-chart-line</v-icon
            >
            <b class="pl-2" style="font-weight: 500">{{
              $t('message.trialModalTitle')
            }}</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-7 py-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card-text
                class="pa-0"
                v-html="$t('message.textLetsStart1')"
              ></v-card-text>
              <v-card-text
                class="pa-0 mt-4 mb-2"
                style="font-weight: bolder"
                v-html="$t('message.textLetsStart2')"
              ></v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-7 pb-6 mt-3">
          <v-spacer></v-spacer>
          <v-btn class="mr-2 px-4" text @click="handleClose">
            {{ $t('message.notYet') }}
          </v-btn>
          <v-btn
            color="primary"
            class="mr-1"
            :disabled="loadingButtonSave"
            :loading="loadingButtonSave"
            @click="handleResetBillingCycle"
          >
            {{ $t('message.startFullPlan') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import planApi from '../services/planApi'
import userApi from '../services/userApi'
import i18n from '@/translations/lang'
import { mapMutations } from 'vuex'

export default {
  name: 'ModalResetBillingCycle',
  components: {},
  data: () => ({
    open: false,
    loadingButtonSave: false,
  }),
  mounted() {
    this.$root.$on('ModalResetBillingCycle', () => {
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('ModalResetBillingCycle')
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_USER_PLAN_INFO',
    ]),
    snackbarWelcomeToPanda() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.welcomeAfterResetBillingCycle'),
      })
      navigator.clipboard.writeText('message.welcomeAfterResetBillingCycle')
    },
    async handleResetBillingCycle() {
      this.loadingButtonSave = true
      try {
        const selector = document.querySelector(
          '.d-none-card-subscription-status'
        )
        await planApi.resetBillingCycle('active')
        const [ret, userLimit] = await Promise.all([
          planApi.getSubscription(),
          userApi.getUserLimit(),
        ])

        this.UPDATE_USER_PLAN_INFO({
          addons: ret.data.addons,
          currency: ret.data.currency,
          subscription_id: ret.data.subscription_id,
          subscription: ret.data.subscriptions,
          limit: userLimit.data,
          planId: ret.data.subscriptions.id,
          subscription_metadata: ret.data.subscription_metadata ?? {},
          type_payment: ret.data.type_payment,
          user: {
            name: ret.data.name,
            email: ret.data.email,
          },
        })

        this.handleClose()
        selector.classList.add('d-none')
        this.snackbarWelcomeToPanda()
      } catch (e) {
        console.log(e)
      }
      this.loadingButtonSave = false
    },
    handleClose() {
      this.open = false
    },
  },
}
</script>
